import { useCookies } from 'react-cookie';

export default function useHasLogined() {
  const [cookies] = useCookies(['u_info', 'lid', 'tid']);

  return cookies.u_info && cookies.lid && cookies.tid;
}
